const length = 20;
const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
const numbers = "0123456789";
const symbols = "!#$%&()*+,-./:;<=>?@[]^_`{|}~";
const wishlist = uppercaseLetters + lowercaseLetters + numbers + symbols;
const isValidPassword = (password) => {
  let [hasUppercase, hasLowercase, hasNumber, hasSymbol] = [false, false, false, false];
  for (let i = 0; i < password.length; i++) {
    const currentCharacter = password.charAt(i);
    if (uppercaseLetters.includes(currentCharacter)) {
      hasUppercase = true;
    }
    if (lowercaseLetters.includes(currentCharacter)) {
      hasLowercase = true;
    }
    if (numbers.includes(currentCharacter)) {
      hasNumber = true;
    }
    if (symbols.includes(currentCharacter)) {
      hasSymbol = true;
    }
  }
  return hasUppercase && hasLowercase && hasNumber && hasSymbol;
};
function generatePassword() {
  let password;
  do {
    password = Array.from(crypto.getRandomValues(new Uint32Array(length))).map((x) => wishlist[x % wishlist.length]).join("");
  } while (!isValidPassword(password));
  return password;
}
export {
  generatePassword
};
//# sourceMappingURL=index.es.js.map
